function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { flatten } from 'flat';
import { brandSymbolsMap } from '..';
import { defaultColorPalettes } from '../foundations';
import { iconSizeMapping } from './icon.types';
export var getBaseIconColors = () => flatten(_objectSpread(_objectSpread({}, defaultColorPalettes), {}, {
  inherit: 'inherit'
}));
export var getIconSize = _ref => {
  var {
    size = 'medium'
  } = _ref;
  return {
    // Using explicit pixels because the icon is an svg and its size is determined by its parent's font-size.
    fontSize: iconSizeMapping[size]
  };
};
export var getImageIconSize = _ref2 => {
  var {
    size = 'medium'
  } = _ref2;
  return {
    width: iconSizeMapping[size],
    minWidth: iconSizeMapping[size],
    height: iconSizeMapping[size],
    minHeight: iconSizeMapping[size]
  };
};
export var isBrandSymbol = icon => Boolean(Object.keys(brandSymbolsMap).includes(icon));
//# sourceMappingURL=utils.js.map